import { transport } from 'config/transport';

export function callApiGetPaymentSummaries(fromDate, toDate) {
    return transport.get(`/mamnon/thuhocsinh/summary`, { params: { fromDate, toDate } });
}
